import { Grid, Theme, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { goToClaimsBtn } from '../../../Constants/Constants';
import CallToAction from '../../shared/CallToAction/CallToAction';

export default function GlassCallUs() {
  const theme: Theme = useTheme();
  const navigate = useNavigate();

  function handleCancel() {
    navigate('/claims-overview');
  }

  return (
    <Grid container sx={{ marginTop: '1rem' }}>
      <Grid item xs={12}>
        <Typography
          sx={{
            ...theme.custom.styles.titleType4,
          }}
        >
          Call us for Glass Claim Assistance
        </Typography>

        <Typography sx={{ marginTop: '2em', marginBottom: '2em' }}>
          We’re here to help you get back on the road. Please contact us for assistance.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <CallToAction
          backButton={false}
          skipButton={false}
          cancelButton={true}
          cancelButtonContent={goToClaimsBtn}
          handleCancel={handleCancel}
        ></CallToAction>
      </Grid>
    </Grid>
  );
}
